/*
 *  size : size of dots
 *  space : space of dots
 *  
 */

class Dots {
  constructor(size, space, color, canvas) {
    this.size = size;
    this.space = space;
    this.color = color;
    this.points = [];
    this.canvas = canvas;
    this.stroleColor;
  }
  init() {
    this.points = [] //particle coordinate
    this.container = new createjs.Container();
    this.grid = {
      x: ~~(this.canvas.width / this.space) + 3,
      y: ~~(this.canvas.height / this.space) + 3
    }
  }
  reset() {
    this.container.removeAllChildren();
    this.grid = {
      x: ~~(this.canvas.width / this.space),
      y: ~~(this.canvas.height / this.space)
    }
  }
  setPoint(loose) {
    let count = 0;
    let alt = 0;
    for (let i = 0; i < this.grid.y; i++) {
      alt = i % 2;
      for (let j = 0; j < this.grid.x; j++) {
        let x = 0,
          y = 0;
        if (loose) {
          let tempRandom = Math.abs( Math.sin( j * Math.sin(i) ) ) * 2 - 1;
          x = j * this.space - this.space / 2 + tempRandom * this.space * 0.3;
          //+ alt * this.space;
          tempRandom = Math.abs(Math.sin( j * Math.cos(i) ) ) * 2 - 1;
          y = i * this.space - this.space / 2 + tempRandom * this.space * 0.3;
        } else {
          x = j * this.space - this.space / 2;
          y = i * this.space - this.space / 2;
        }
        this.points[count] = [x, y];
        count++;
      }
    }
  }
  draw(strokeWidth, strokeColor, alpha) {
    this.strokeColor = strokeColor;
    for (let i of this.points) {
      let circle = new createjs.Shape();

      if (strokeWidth) {
        circle.strokeProperty = circle.graphics.setStrokeStyle(strokeWidth).beginStroke(strokeColor).command;
      }
      circle.fillProperty = circle.graphics.beginFill(this.color).command;
      circle.graphics.drawCircle(0, 0, this.size).command;

      circle.x = parseInt(i.slice(0, 1));
      circle.y = parseInt(i.slice(1));
      let tempRandom = Math.abs( Math.sin(circle.y) );
      circle.randomX = ( tempRandom * 2 - 1 );
      circle.randX = circle.randomX * this.space;
      tempRandom = Math.abs( Math.cos(circle.y) );
      circle.randomY = ( tempRandom * 2 - 1 );
      circle.randY = circle.randomY * this.space;
      circle.defX = circle.x;
      circle.defY = circle.y;
      if (alpha) {
        circle.alpha = alpha;
      }
      //circle.cache(circle.x, circle.y, circle.width, circle.height);
      this.container.addChild(circle);
    }
  }
  nextline(vert , grid) {
    let element = vert;
    let elemLen = element.length;
    for (let i = 0; i < elemLen - 1; i++) {
      let line = new createjs.Shape();
      line.strokeProperty = line.graphics.setStrokeStyle(1).beginStroke(this.color);
      //下へのラインが引けない時
      if (element[i + grid] !== undefined) {
        line.graphics.moveTo(element[i].x, element[i].y);
        line.graphics.lineTo(element[i + grid].x, element[i + grid].y);
        if (element[i + 1 + grid] && (i + 1 + grid) % grid !== 0 ) {
          line.graphics.moveTo(element[i].x, element[i].y);
          line.graphics.lineTo(element[i + 1 + grid].x, element[i + 1 + grid].y);
        }
      }
      //一番右端を除く
      if (i % grid !== grid - 1) {
        line.graphics.moveTo(element[i].x, element[i].y);
        line.graphics.lineTo(element[i + 1].x, element[i + 1].y);
      }
      
      this.container.addChild(line);
    }

  }
  triangle(vert) {
    let triPoints = vert;
    let triLen = triPoints.length;
    let amount;
    let columNum = ~~ (this.canvas.width / this.space * 1.5 );
    if(this.canvas.width < 750){
      amount = [4, columNum, 5, 10 ];
    }else{
      amount = [7, columNum, 5, 20 , 19 , 3, columNum];
    }
    
/**
 *  ドットの順番（横列）で三角形の頂点をきめる。1番目だけは取り敢えず表示。
 * 
 */
    let flg = 0;
    let trig = 1;
    for (let m = 0; m < triLen; m++) {
      if ((trig == amount[0]) || (m == trig)) {
        trig = m + amount[flg % amount.length];
        flg++;

        let tri = new createjs.Shape();
        let basePoint;
        let nextPoint;
        let underPoint;
        let max = m % this.grid.x;
        if (max == 0 || max == this.grid.x - 1) {
          basePoint = triPoints[m + 1];
          nextPoint = triPoints[m + 2];
          underPoint = triPoints[m + 2 + this.grid.x];
          if (underPoint == null) continue;
        } else {
          if( m % 2 == 0){
            basePoint = triPoints[m];
            nextPoint = triPoints[m + this.grid.x];
            underPoint = triPoints[m + 1 + this.grid.x];
          }else{
            basePoint = triPoints[m];
            nextPoint = triPoints[m + 1];
            underPoint = triPoints[m + 1 + this.grid.x];
          }
          if (underPoint == null) continue;
        }
        tri.fillProperty = tri.graphics.beginFill(this.color).command;
        //tri.strokeProperty = tri.graphics.setStrokeStyle(1).beginStroke('rgba(215,215,215,1)').command;
        tri.graphics.moveTo(basePoint.x, basePoint.y);
        tri.graphics.lineTo(nextPoint.x, nextPoint.y);
        tri.graphics.lineTo(underPoint.x, underPoint.y);
        tri.graphics.lineTo(basePoint.x, basePoint.y);
        this.container.addChild(tri);
      }
    }
  }
}
